import { __assign, __read, __spread } from "tslib";
import React, { useEffect, useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Graticule, MapPath, Sphere } from './components';
import { detectGeographicMatch, } from './utils';
import { ChartContext } from '../../contexts';
var defaultGeometry = {
    data: {},
    index: null,
};
var mapPathMotion = {
    initial: { opacity: 0 },
    exit: { opacity: 0 },
    animate: { opacity: 1 },
};
export var Map = function (_a) {
    var valueKey = _a.valueKey, elementsKey = _a.elementsKey, topology = _a.topology, drawPath = _a.drawPath, graticule = _a.graticule, geoData = _a.geoData, getColor = _a.getColor, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onUpdateGeoMatchStatus = _a.onUpdateGeoMatchStatus, valuesRange = _a.valuesRange;
    var _b = useContext(ChartContext).theme.choropleth, map = _b.map, graticuleSettings = _b.graticule, sphereSettings = _b.sphere;
    var features = topology.features;
    useEffect(function () {
        if (onUpdateGeoMatchStatus) {
            var matchStatus = detectGeographicMatch(topology, __spread(geoData.keys()));
            onUpdateGeoMatchStatus(matchStatus);
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        sphereSettings.enabled && (React.createElement(Sphere, { background: sphereSettings.backgroundColor, draw: drawPath })),
        graticuleSettings.enabled && (React.createElement(Graticule, { stroke: graticuleSettings.color, draw: drawPath, graticule: graticule })),
        React.createElement(AnimatePresence, null, features.map(function (geometry, idx) {
            var _a = geometry.properties, name = _a.name, iso3166 = _a.iso_3166_2, postAbbreviation = _a.postAbbreviation;
            var geometryProperties = geoData.get(name) ||
                geoData.get(iso3166) ||
                geoData.get(postAbbreviation) ||
                defaultGeometry;
            var value = geometryProperties.data[valueKey] || 0;
            var inRange = valuesRange
                ? value >= valuesRange.min && value <= valuesRange.max
                : true;
            if (!inRange)
                return null;
            var color = getColor(value);
            var meta = {
                color: color,
                value: value,
                elements: elementsKey && geometryProperties.data[elementsKey],
                label: name,
            };
            return (React.createElement(motion.g, __assign({ key: name + "-" + idx, onMouseEnter: function (e) { return onMouseEnter(e, meta); }, onMouseMove: function (e) { return onMouseEnter(e, meta); }, onMouseLeave: function (e) { return onMouseLeave(e); } }, mapPathMotion),
                React.createElement(MapPath, { path: drawPath(geometry), fill: color, strokeWidth: "0.5", stroke: map.stroke })));
        }))));
};
export default Map;
